const { wrapPageElement } = require('./dist/wrap-page-element');
exports.wrapPageElement = wrapPageElement;
